import _ from 'lodash'
import statusProcesso from '@/constants/statusProcessosCentral'
import estadosCivilGeral from '@/constants/estadoCivil'
const { setores, nomesSetores } = require('./setor').default

const setStatus = (prop) => {
  if (prop.setor === setores.GAC && prop.status === 'AGUARDANDO_ANALISE') {
    return 'Aguardando análise'
  } else if (prop.status === 'PROCESSO_DEFERIDO') {
    return 'Deferido'
  } else if (prop.status === 'PROCESSO_INDEFERIDO') {
    return 'Indeferido'
  } else if (prop.status !== 'FINALIZADO' || prop.status !== 'ARQUIVADO') {
    return 'Em análise'
  }

  const status = _.find(statusProcesso, sts => sts.codigo === prop)
  return status ? status.nome : '-'
}

const setSetor = (prop) => {
  switch (prop) {
    case setores.PROTOCOLO:
      return nomesSetores.PROTOCOLO
    case setores.JURIDICO:
      return nomesSetores.JURIDICO
    case setores.DRF:
      return nomesSetores.DRF
    case setores.DF1:
      return nomesSetores.DF1
    case setores.DF3:
      return nomesSetores.DF3
    case setores.COMISSAO_ILHA:
      return nomesSetores.COMISSAO_ILHA
    case setores.DATGL:
      return nomesSetores.DATGL
    case setores.PRESIDENCIA:
      return nomesSetores.PRESIDENCIA
    case setores.CAF:
      return nomesSetores.CAF
    case setores.CAS:
      return nomesSetores.CAS
    case setores.CTT:
      return nomesSetores.CTT
    case setores.DADR:
      return nomesSetores.DADR
    case setores.CEP:
      return nomesSetores.CEP
    case setores.DAF:
      return nomesSetores.DAF
    case setores.CADR:
      return nomesSetores.CADR
    case setores.DUF:
      return nomesSetores.DUF
    case setores.DEO:
      return nomesSetores.DEO
    case setores.DUA:
      return nomesSetores.DUA
    case setores.DGRH:
      return nomesSetores.DGRH
    case setores.DMP:
      return nomesSetores.DMP
    case setores.PRODUTIVIDADE:
      return nomesSetores.PRODUTIVIDADE
    case setores.RELATORIOS:
      return nomesSetores.RELATORIOS
    case setores.FINANCEIRO:
      return nomesSetores.FINANCEIRO
    case setores.GOVERNO:
      return nomesSetores.GOVERNO
    case setores.PARAMETRIZACAO:
      return nomesSetores.PARAMETRIZACAO
    case setores.GABINETE:
      return nomesSetores.GABINETE
    default: return '-'
  }
}

const estadosCivil = estadosCivilGeral.filter(e => e.codigo !== 'UNIAO_HOMOAFETIVA' && e.codigo !== 'SEPARADO')

const tipoDocumentos = ['CNH', 'RG', 'OUTROS']

const tiposProcessosFisicos = ['NAO_ONEROSO_FISICO', 'ONEROSO_FISICO']

const labelsCadastro = {
  imovel: {
    denominacao: 'Denominação do imóvel:',
    colonia: 'Nome da gleba:',
    lote: 'N° do processo:'
  },
  interessado: {
    prefeitura: 'Órgão publico:',
    cpfPrefeito: 'CPF do principal gestor:',
    nomePrefeito: 'Nome do principal gestor:'
  },
  endereco: 'Endereço do órgão público'
}

const inputsExtraCadastro = {
  imovel: {
    dataMatricula: true,
    nomeImovelPropriedade: true,
    numeroTitulo: false,
    escrituraDocumentoRegistro: true
  },
  georreferencia: {
    texto: true
  }
}

const profissoes = () => {
  return [{
    'id': 1,
    'nome': 'Agricultor',
    'codigo': 'AGRICULTOR'
  },
  {
    'id': 2,
    'nome': 'Agropecuarista',
    'codigo': 'AGROPECUARISTA'
  },
  {
    'id': 3,
    'nome': 'Comerciante',
    'codigo': 'COMERCIANTE'
  },
  {
    'id': 4,
    'nome': 'Pecuarista',
    'codigo': 'PECUARISTA'
  },
  {
    'id': 5,
    'nome': 'Servidor Público',
    'codigo': 'SERVIDOR_PUBLICO'
  },
  {
    'id': 6,
    'nome': 'Outro',
    'codigo': 'OUTRO'
  }]
}

const georreferenciamentoSigef = false

const notificacaoWhatsApp = false

const buttonOpcoes = {
  showButonVisualizarProcesso: false
}

const switchHabilitar = {
  showSwitchHabilitar: false
}

const showButtonOficio = true

const tiposProcessos = [
  {
    codigo: 'CANCELAMENTO_CLAUSULA_RESOLUTIVA',
    nome: 'Cancelamento de cláusula resolutiva'
  },
  {
    codigo: 'NAO_ONEROSO',
    nome: 'Não Oneroso'
  },
  {
    codigo: 'NAO_ONEROSO_FISICO',
    nome: 'Não Oneroso (físico)'
  },
  {
    codigo: 'ONEROSO',
    nome: 'Oneroso'
  },
  {
    codigo: 'ONEROSO_FISICO',
    nome: 'Oneroso (físico)'
  },
  {
    codigo: 'PEAS',
    nome: 'PEAS'
  },
  {
    codigo: 'REURB_COLETIVO',
    nome: 'Reurb coletivo'
  },
  {
    codigo: 'REURB_INDIVIDUAL',
    nome: 'Reurb individual'
  },
  {
    codigo: 'TT',
    nome: 'Territórios Tradicionais'
  }
]

const tiposArea = [
  {
    nome: 'Ha',
    codigo: 'HECTARE',
    id: 1
  },
  {
    nome: 'm²',
    codigo: 'M2',
    id: 2
  },
  {
    nome: 'Linha',
    codigo: 'LINHA',
    id: 3
  }
]

const filtro = {
  placeholder: 'Número do processo, Nome/Razão social do Interessado, CPF/CNPJ do interessado, ou Tipo do processo',
  showFiltroTipoProcessoMultiplo: false,
  filtroNumeroRecibo: {
    LISTAGEM_RECEPTOR_CADASTROS_PENDENTES: []
  },
  filtroSituacao: {
    LISTAGEM_RECEPTOR_CADASTROS_PENDENTES: []
  }
}

export default {
  setSetor,
  setStatus,
  estadosCivil,
  tipoDocumentos,
  profissoes,
  labelsCadastro,
  inputsExtraCadastro,
  georreferenciamentoSigef,
  notificacaoWhatsApp,
  buttonOpcoes,
  switchHabilitar,
  showButtonOficio,
  tiposProcessos,
  tiposProcessosFisicos,
  tiposArea,
  filtro
}



// WEBPACK FOOTER //
// ./src/utils/ma/regrasCentral.js